import { z } from 'zod';

export const PostfixComparisonAttributesSchema = z.enum(['value', 'length', 'type', 'property']);

export type PostfixComparisonAttributes = z.infer<typeof PostfixComparisonAttributesSchema>;
